import React, { useState, useEffect } from "react";
import "./scroll.css"

const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);

  // Affiche le bouton uniquement lorsque l'utilisateur fait défiler vers le bas
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Fonction pour remonter en haut de la page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {showButton && (
        <button
          onClick={scrollToTop}
          className="scroll-to-top"
          title="Remonter en haut"
        >
          ⬆️
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
